import { getCookie } from 'cookies-next'
import { cookieKeys } from 'lib/consts/browserStorage'

interface GetAuthorizationHeadersParams {
  externalToken?: Maybe<string>
}

export const getAuthorizationHeaders = ({ externalToken }: GetAuthorizationHeadersParams = {}) => {
  const authToken = externalToken || getCookie(cookieKeys.token)
  const headers: Record<string, string> = {}

  if (authToken) {
    headers.Authorization = `Bearer ${authToken}`
  }

  return headers
}
